import { render, staticRenderFns } from "./VerifyPhoneModal.vue?vue&type=template&id=f8de9b4a&scoped=true&"
import script from "./VerifyPhoneModal.vue?vue&type=script&lang=js&"
export * from "./VerifyPhoneModal.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPhoneModal.vue?vue&type=style&index=0&id=f8de9b4a&prod&lang=css&"
import style1 from "./VerifyPhoneModal.vue?vue&type=style&index=1&id=f8de9b4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8de9b4a",
  null
  
)

export default component.exports